import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

const ServicesData = [
    {
        'icon': iconOne,
        'title': 'Smile Card (Family Plan)',
        'price': '₹499/year',
        'members': '4 Members',
        'description': 'Perfect for families! Get comprehensive dental care for your entire family at an affordable price.',
        'features': [
            'Free dental check-up for all 4 members',
            '15% OFF on all treatments',
            'Priority appointment booking',
            'Annual dental health reports'
        ],
        'highlight': 'Most Popular'
    },
    {
        'icon': iconTwo,
        'title': 'Student Dental Health Card',
        'price': '₹99/student',
        'members': 'Student + Parents',
        'description': 'Special plan designed for students with additional benefits for parents.',
        'features': [
            'Free dental check-up for student',
            'Free brushing demonstration',
            '15% discount for parents',
            'Educational dental materials'
        ],
        'highlight': 'Best Value'
    },
    {
        'icon': iconThree,
        'title': 'Free Dental Check-Up',
        'price': 'FREE',
        'members': 'Everyone',
        'description': 'Comprehensive dental examination and consultation at absolutely no cost.',
        'features': [
            'Complete oral examination',
            'X-ray consultation',
            'Treatment planning',
            'Oral hygiene guidance'
        ],
        'highlight': 'Limited Time'
    },
    {
        'icon': iconFour,
        'title': '15% OFF All Treatments',
        'price': '15% OFF',
        'members': 'All Patients',
        'description': 'Get 15% discount on all dental treatments and procedures.',
        'features': [
            'Root canal treatments',
            'Dental implants',
            'Cosmetic procedures',
            'Orthodontic treatments'
        ],
        'highlight': 'Special Offer'
    }
]

export default ServicesData;